import * as React from "react";
import {
  SelectInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  maxValue,
  minValue,
  NumberInput,
} from "react-admin";
import { GAS_BRAND_MERCHANT_STATUSES } from "@local/app/constants/index.js";

const EditGasBrandMerchantFuel = () => (
  <ArrayInput source="fuels" label="">
    <SimpleFormIterator
      inline
      disableClear={true}
      disableReordering={true}
      disableRemove={true}
    >
      <TextInput
        source="name"
        label="resources.GasBrandMerchant.fuels.name"
        validate={[required()]}
        inputProps={{ maxLength: 55, minLength: 1 }}
      />
      <TextInput
        source="alias_fuel_type"
        label="resources.GasBrandMerchant.fuels.alias_fuel_type"
        validate={[required()]}
        inputProps={{ maxLength: 55, minLength: 1 }}
      />
      <NumberInput
        source="regular_price"
        label="resources.GasBrandMerchant.fuels.stella_price"
        validate={[required(), maxValue(2147483647), minValue(0)]}
      />
      <NumberInput
        source="discount_price"
        label="resources.GasBrandMerchant.fuels.coupon_price"
        validate={[required(), maxValue(2147483647), minValue(0)]}
      />
      <SelectInput
        source="status"
        label="resources.GasBrandMerchant.fuels.status"
        validate={[required()]}
        choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => {
          if (status === "blocked") {
            return "";
          }

          return {
            id: status,
            name: `resources.GasBrandMerchant.source.status.${status}`,
          };
        })}
      />
    </SimpleFormIterator>
  </ArrayInput>
);

export { EditGasBrandMerchantFuel };
